import { ProductColor } from '@aloft/toolkit-sui';
import { BorderProps } from '@aloft/toolkit-sui/chakra';

export const borderWidth = '0.75px';
export const borderColor: ProductColor = 'surface4';
export const borderStyle: BorderProps['borderStyle'] = 'solid';
export const borderSideStyle: BorderProps['borderRightStyle'] | BorderProps['borderBottomStyle'] =
  borderStyle;
